import { Image, StyleSheet, Text, View } from "@react-pdf/renderer";
import { GOAL_TRACK_PARAMETERS } from "config/constants";
import { globalStyles } from "config/pdfStyles";
import { getGoalTrackingPercentage } from "helpers/assessment";

const styles = StyleSheet.create({
  goalDetailOuter: {
    backgroundColor: "#fbfbe6",
    padding: "20px",
    marginBottom: "20px",
    borderRadius: "5px",
    flexDirection: "row",
    gap: "20px"
  },
  goalDetailField: {
    borderRadius: "5px",
    backgroundColor: "#f2f3da",
    padding: "10px 15px"
  },
  trackingChartOuter: {
    backgroundColor: "#e8f2e0",
    borderRadius: "5px",
    padding: 20
  }
});

const GoalReviewSection = ({ assessmentGoals, therapistDetails, showChart = false, chartImages = [] }) => {
  console.log("GoalReviewSection",therapistDetails?.caseDiscipline?.name)
  return (
    <>
      <View style={{ display: "flex", flexDirection: "row", alignItems: "center", gap: "10px", marginBottom: "10px" }}>
        <Text style={globalStyles.reportQuestion}>
          Discipline
        </Text>
        <Text style={[globalStyles.textInput, globalStyles.fontBold]}>
          {therapistDetails?.caseDiscipline?.name}
        </Text>
      </View>
      {assessmentGoals?.length > 0 && assessmentGoals?.map((goal, index) => (
        <View style={styles.goalDetailOuter} wrap={false}>
          <View style={{ width: "60%" }}>
            <View style={[globalStyles.table, globalStyles.reportQuestionOuter, { paddingTop: "0" }]}>
              <View style={globalStyles.tableRow}>
                <Text style={[globalStyles.tableHead, { width: "10%" }]}>{index + 1}.</Text>
                <Text style={[globalStyles.tableHead, { width: "20%" }]}>Area</Text>
                <Text style={[globalStyles.tableHead, { width: "50%" }]}>Goal</Text>
                <Text style={[globalStyles.tableHead, { width: "20%" }]}>Context</Text>
              </View>
              <View style={globalStyles.tableRow}>
                <Text style={[globalStyles.tableColumn, { width: "10%" }]}></Text>
                <Text style={[globalStyles.tableColumn, { width: "20%" }]}>
                  {goal?.assesmentGoalDisciplineArea?.name}
                </Text>
                <Text style={[globalStyles.tableColumn, { width: "50%" }]}>
                  {goal?.assesmentGoalDetail?.title}
                </Text>
                <Text style={[globalStyles.tableColumn, { width: "20%" }]}>
                  {goal?.assesmentGoalContext?.context}
                </Text>
              </View>
            </View>
            <View style={globalStyles.reportQuestionOuter}>
              <Text style={globalStyles.reportQuestion}>
                Goal Details
              </Text>
              <Text style={styles.goalDetailField}>
                {goal?.goal_description}
              </Text>
            </View>
            <View style={[globalStyles.reportQuestionOuter, { paddingBottom: 0 }]}>
              <Text style={[globalStyles.reportQuestion, { fontSize: "11px" }]}>
                Goal Review
              </Text>
              <Text style={styles.goalDetailField}>
                {goal?.goal_notes}
              </Text>
            </View>
          </View>
          {showChart && (
            <View style={{ width: "40%" }}>
              <View style={styles.trackingChartOuter}>
                <Image
                  src={chartImages[index]}
                />
                {goal?.goalTracking?.length > 0 ? (
                  <View>
                    {Object.entries(GOAL_TRACK_PARAMETERS)?.map(([param, label], index) => {
                      let parameterPercentage =
                        getGoalTrackingPercentage(
                          param,
                          goal?.goalTracking
                        );
                      return (
                        <View
                          key={index}
                          style={{
                            flexDirection: "row",
                            justifyContent: "space-between",
                            padding: "5px 10px"
                          }}
                        >
                          <Text className="m-0">
                            <Text style={globalStyles.fontBold}>
                              {param}
                            </Text>
                            {" - "}
                            {label}
                          </Text>
                          <Text style={globalStyles.fontBold}>
                            {parameterPercentage} %
                          </Text>
                        </View>
                      );
                    }
                    )}
                  </View>
                ) : (
                  <Text>
                    Goal not tracked yet
                  </Text>
                )}
              </View>
            </View>
          )}
        </View>
      ))}
    </>
  )
}


export default GoalReviewSection;